var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#67D449",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.192 23.17c-.206.576-1.193 1.102-1.667 1.173-.425.064-.964.09-1.555-.097a14.387 14.387 0 0 1-1.407-.52c-2.477-1.07-4.096-3.564-4.22-3.728-.123-.164-1.008-1.338-1.008-2.553 0-1.215.638-1.813.865-2.06a.907.907 0 0 1 .658-.31c.165 0 .33.002.474.01.152.007.355-.058.555.423.206.495.7 1.71.762 1.833.06.124.102.268.02.433-.083.164-.124.268-.247.412-.123.143-.26.322-.37.433-.124.122-.253.256-.109.503.145.247.64 1.055 1.374 1.71.943.84 1.74 1.101 1.986 1.226.247.123.391.102.535-.063.144-.164.618-.72.782-.968.165-.246.329-.205.556-.123.225.082 1.44.679 1.687.804.247.123.411.184.474.287.06.104.06.597-.145 1.174m-4.831-11.74c-4.53 0-8.217 3.683-8.218 8.21 0 1.552.433 3.063 1.256 4.37l.196.31-.83 3.031 3.109-.815.299.177a8.19 8.19 0 0 0 4.18 1.145h.004c4.527 0 8.212-3.683 8.214-8.212a8.162 8.162 0 0 0-2.403-5.809 8.16 8.16 0 0 0-5.807-2.407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.041 29.828h-.003c-1.66 0-3.29-.417-4.738-1.207L10.044 30l1.407-5.136a9.884 9.884 0 0 1-1.324-4.955C10.13 14.445 14.578 10 20.041 10a9.844 9.844 0 0 1 7.013 2.906 9.848 9.848 0 0 1 2.901 7.011c-.002 5.464-4.45 9.91-9.914 9.91M20 0C8.954 0 0 8.954 0 20c0 11.045 8.954 20 20 20 11.045 0 20-8.955 20-20C40 8.954 31.045 0 20 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.2cf543d0ba3345c282aacb3294b3da0a.svg";
export { ForwardRef as ReactComponent };